<template>
  <div v-if="display">
    <agile-table
      :data-type="'licenses'"
      :data="licenses"
      :tableMeta="tableMeta"
      :filter-meta="filterMetaFinal"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openLicenseModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import LicenseModal from '@/components/modals/LicenseModal'

export default {
  props: {
    title: {
      type: String,
      required: false
    },

    filterMeta: {
      type: Array,
      required: false
    },

    customerId: {
      type: Number,
      required: false
    }
  },

  components: {
    NewButton,
    AgileTable
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      display: false,

      tableMeta: {
        headingIcon: 'fa-file-certificate',
        title: this.title
      },

      filterMetaDefault: [{
        fieldId: 'customerName',
        type: 'string',
        label: 'Kund'
      },
      {
        fieldId: 'product',
        type: 'select',
        label: 'Produkt',
        options: [{
          key: 'InteractiveBowling',
          value: 'Interactive Bowling'
        }, {
          key: 'InteractivePanel',
          value: 'Interactive Panel'
        }]
      },
      {
        fieldId: 'licenseKey',
        type: 'string',
        label: 'Licensnyckel'
      },
      {
        fieldId: 'cpuId',
        type: 'string',
        label: 'CPU-ID'
      },
      {
        fieldId: 'valid',
        type: 'select',
        label: 'Licens giltig',
        options: [{
          key: true,
          value: 'Giltiga'
        }, {
          key: false,
          value: 'Ej giltiga'
        }]
      }
      ],

      filterMetaFinal: [],

      columnMeta: {
        hasActions: true,
        items: [
          {
            fieldId: 'valid',
            label: 'Valid',
            dataType: 'success-warning-error'
          },
          {
            fieldId: 'customerName',
            label: 'Kund'
          },
          {
            fieldId: 'product',
            label: 'Produkt',
            dataType: 'translate',
            translations: [{
              key: 'InteractiveBowling',
              value: 'Interactive Bowling'
            }, {
              key: 'InteractivePanel',
              value: 'Interactive Panel'
            }]
          },
          {
            fieldId: 'licenseEndDate',
            label: 'Slutdatum',
            dataType: 'date'
          },
          {
            fieldId: 'installationDate',
            label: 'Installerat',
            dataType: 'date'
          },
          {
            fieldId: 'installedByFullName',
            label: 'Installerad av'
          },
          // {
          //   fieldId: 'licenseKey',
          //   label: 'Licensnyckel',
          //   disableOrdering: true
          // },
          {
            fieldId: 'lastCheckDate',
            dataType: 'dateTime',
            label: 'Senaste kontroll'
          }
          // {
          //   fieldId: 'cpuId',
          //   label: 'CPU-ID',
          //   disableOrdering: true
          // }
        ]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateLicense',
          iconClass: 'fal fa-pen'
        }, {
          label: null,
          action: 'deleteLicense',
          iconClass: 'fal fa-xmark',
          buttonClass: 'is-danger'
        }]
      }
    }
  },

  watch: {
    'licenses.filter': {
      handler () {
        this.$store.state.licenses.all.currentPage = 1
        this.getListData().then(() => {
          this.display = true
        })
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      licenses: state => state.licenses.all
    })
  },

  methods: {
    ...mapActions('licenses', ['initialize', 'getListData', 'delete']),

    rowAction (action, license) {
      switch (action) {
        case 'updateLicense':
          this.openLicenseModal(license.licenseId)
          break
        case 'deleteLicense':
          this.deleteLicense(license)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, license) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openLicenseModal (licenseId) {
      this.$panel(LicenseModal, { licenseId, customerId: this.customerId }).then(() => {
        console.log(this.licenses.items)
      })
    },

    deleteLicense (license) {
      console.log(license)
      this.$confirm('Radera licens', 'Är du säker på att du vill radera licensen ' + license.productName + '?').then((result) => {
        if (result.value) {
          this.delete(license.licenseId)
          this.getListData(1)
        }
      })
    }
  },

  created () {
    this.initialize()

    if (this.customerId) {
      this.licenses.defaultFilter.customerId = this.customerId
      this.licenses.filter.customerId = this.customerId
    }
    else {
      this.licenses.defaultFilter.customerId = null
      this.licenses.filter.customerId = null
    }

    if (this.filterMeta === null) {
      this.filterMetaFinal = null
    }
    else if (this.filterMeta) {
      this.filterMetaFinal = this.filterMeta
    }
    else {
      this.filterMetaFinal = this.filterMetaDefault
    }

    if (!this.display) {
      this.getListData().then(() => {
        this.display = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/License/LicensesPage.vue